import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";

import Navbar from "./components/NavBar/NavBar";
import PermissionRoute from "./components/PermissionRoutes/PermissionRoutes";

import Login from "./pages/Login/Login";
import AdminDashboard from "./pages/AdminDashboard/AdminDashboard";
import HelpAndSupport from "./pages/HelpAndSupport/HelpAndSupport";
import NotificationAndAlerts from "./pages/NotificationAndAlerts/NotificationAndAlerts";
import ReportsAndAnalytics from "./pages/ReportsAndAnalytics/ReportsAndAnalytics";
import Settings from "./pages/Settings/Settings";
import UserManagement from "./pages/UserManagement/UserManagement";
import UserManagementEdit from "./pages/UserManagementEdit/UserManagementEdit";
import UserManagementCreate from "./pages/UserManagementCreate/UserManagementCreate";
import VendorManagement from "./pages/VendorManagement/VendorManagement";
import VendorManagementCreate from "./pages/VendorManagementCreate/VendorManagementCreate";
import VendorManagementEdit from "./pages/VendorManagementEdit/VendorManagementEdit";
import RoleManagement from "./pages/RoleManagement/RoleManagement";
import RoleManagementCreate from "./pages/RoleManagementCreate/RoleManagementCreate";
import RoleManagementEdit from "./pages/RoleManagementEdit/RoleManagementEdit";
import ProjectManagement from "./pages/ProjectManagement/ProjectManagement";
import ProjectManagementCreate from "./pages/ProjectManagementCreate/ProjectManagementCreate";
import ProjectManagementEdit from "./pages/ProjectManagementEdit/ProjectManagementEdit";
import TrackerPanel from "./pages/TrackerPanel/TrackerPanel";
import Profile from "./pages/Profile/Profile";
import DynamicManagementPage from "./pages/DynamicListPage/DynamicListPage";
import DynamicCreatePage from "./pages/DynamicCreatePage/DynamicCreatePage";
import DynamicEditPage from "./pages/DynamicEditPage/DynamicEditPage";

const App = () => {
  const privateRoutes = [
    { path: "/", component: <AdminDashboard /> },
    // { path: '/user', permission: 'user:view', component: <UserManagement /> },
    // {
    //   path: "/user/create",
    //   permission: "user:create",
    //   component: <UserManagementCreate />,
    // },
    {
      path: "/user/:id",
      permission: "user:edit",
      component: <UserManagementEdit />,
    },
    {
      path: "/vendor",
      permission: "vendor:view",
      component: <VendorManagement />,
    },
    {
      path: "/vendor/create",
      permission: "vendor:create",
      component: <VendorManagementCreate />,
    },
    {
      path: "/vendor/:id",
      permission: "vendor:edit",
      component: <VendorManagementEdit />,
    },
    // { path: "/role", permission: "role:view", component: <RoleManagement /> },
    {
      path: "/role/create",
      permission: "role:create",
      component: <RoleManagementCreate />,
    },
    {
      path: "/role/:id",
      permission: "role:edit",
      component: <RoleManagementEdit />,
    },
    // {
    //   path: "/project",
    //   permission: "project:view",
    //   component: <ProjectManagement />,
    // },
    {
      path: "/project/create",
      permission: "project:create",
      component: <ProjectManagementCreate />,
    },
    {
      path: "/project/:id",
      permission: "project:edit",
      component: <ProjectManagementEdit />,
    },
    {
      path: "/Tracker",
      permission: "tracker:view",
      component: <TrackerPanel />,
    },
    {
      path: "/reports",
      permission: "reports:view",
      component: <ReportsAndAnalytics />,
    },
    {
      path: "/notification",
      permission: "notification:view",
      component: <NotificationAndAlerts />,
    },
    { path: "/settings", permission: "settings:view", component: <Settings /> },
    { path: "/profile", permission: "profile:view", component: <Profile /> },
    {
      path: "/helpsupport",
      permission: "support:access",
      component: <HelpAndSupport />,
    },
  ];

  return (
    <Router>
      <ToastContainer position="top-right" autoClose={3000} />
      <Routes>
        {/* 🔓 Public Login Route */}
        <Route
          path="/login"
          element={
            <PermissionRoute isPublic>
              <Login />
            </PermissionRoute>
          }
        />

        {/* 🔐 Private and Permission Routes */}
        {privateRoutes.map(({ path, component, permission }) => (
          <Route
            key={path}
            path={path}
            element={
              <PermissionRoute permission={permission}>
                <Navbar />
                {component}
              </PermissionRoute>
            }
          />
        ))}
        <Route
          path="/dynamic/:key"
          element={
            <PermissionRoute dynamic>
              <Navbar />
              <DynamicManagementPage />
            </PermissionRoute>
          }
        />
        <Route
          path="/dynamic/:key/:id"
          element={
            <PermissionRoute dynamic>
              <Navbar />
              <DynamicEditPage />
            </PermissionRoute>
          }
        />
        <Route
          path="/:key/create"
          element={
            <PermissionRoute dynamic>
              <DynamicCreatePage />
            </PermissionRoute>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
